<script>
import axios from 'axios';
import router from '@/router';
/*import logoutButton from './logout-button';*/
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import progressContainer from './progressContainer';
import { us_states } from '@/state/helpers';
import { maxLength, requiredIf } from 'vuelidate/lib/validators';

export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { /*logoutButton ,*/ Header, Footer, progressContainer },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			backToOverview: false,
			states: [],
			userData: JSON.parse(localStorage.getItem('web_user')),
			addFaithForm: {
				attend_worship: 0,
				location: '',
				city: '',
				state: '',
				faith_involvement: '',
				faith_journey: '',
				user_type_id: '',
			},
			typeSubmit: false,
			isShow: false,
			errors: [],
		};
	},
	validations: {
		addFaithForm: {
			location: {
				requiredIf: requiredIf(function () {
					return this.addFaithForm.attend_worship == 1;
				}),
			},
			city: {
				requiredIf: requiredIf(function () {
					return this.addFaithForm.attend_worship == 1;
				}),
			},
			state: {
				requiredIf: requiredIf(function () {
					return this.addFaithForm.attend_worship == 1;
				}),
			},
			faith_involvement: {
				requiredIf: requiredIf(function () {
					// return this.addFaithForm.attend_worship == 1;
					return this.userData['user_type_id'] == 3;
				}),
			},
			faith_journey: {
				requiredIf: requiredIf(function () {
					// return this.addFaithForm.attend_worship == 1;
					return this.userData['user_type_id'] == 3;
				}),
				maxLength: maxLength(2500),
			},
		},
	},
	mounted() {
		this.getFaith();
		this.getSubmitFormStats();
		this.setStatesProps();
	},
	methods: {
		// set states
		setStatesProps() {
			us_states.forEach((state) => {
				this.states.push({ value: state, text: state });
			});
		},
		skipToReview() {
			router.push({ name: 'review-application' });
		},

		backgroundCheckDetails() {
			router.push({ name: 'background-check' });
		},
		questions() {
			router.push({ name: 'questions' });
		},
		addFaith() {
			if (this.addFaithForm.attend_worship == 0) {
				// this.addFaithForm.faith_journey = "";
				// this.addFaithForm.faith_involvement = "";
				this.typeSubmit = false;
				this.addFaithForm.city = '';
				this.addFaithForm.location = '';
				this.addFaithForm.state = '';
				if (this.addFaithForm.faith_journey == '') {
					this.typeSubmit = true;
					this.$v.$touch();
					if (!this.$v.$invalid) {
						this.saveFaith();
					}
				} else {
					this.saveFaith();
				}
			} else {
				// stop here if form is invalid
				this.typeSubmit = true;
				this.$v.$touch();
				if (!this.$v.$invalid) {
					this.saveFaith();
				}
			}
		},
		saveFaith() {
			var userData = JSON.parse(localStorage.getItem('web_user'));
			var config = {
				headers: { Authorization: 'Bearer ' + userData.token },
			};
			if (userData.token) {
				this.addFaithForm.user_type_id = userData['user_type_id'];
				axios
					.post('user/faith', this.addFaithForm, config)
					.then((res) => {
						if (res.status == 200) {
							// if (userData.user_type_id === 3 && !userData.is_mentor){
							//   router.push({ name: 'faith'})

							// }
							// else {
							//   router.push({ name: 'additional-details'})
							// }
							router.push({ name: 'additional-details' });
						}
					})
					.catch((err) => {
						if (err.response) {
							this.isShow = true;
							this.errors = err.response.data.error.message;
						}
					});
			}
		},
		// Getting Current User Forms States
		getSubmitFormStats() {
			let formCompleted = true;
			var userData = JSON.parse(localStorage.getItem('web_user'));
			var config = {
				headers: { Authorization: 'Bearer ' + userData['token'] },
			};
			if (userData.token) {
				axios
					.get('user/registration/submitted-forms?user_type_id=' + userData['user_type_id'], config)
					.then((res) => {
						// Mentor
						if (userData['user_type_id'] == 3) {
							if (res.data.response.additional_details === false) {
								formCompleted = false;
							}
							if (res.data.response.background === false) {
								formCompleted = false;
							}
							if (res.data.response.faith === false) {
								formCompleted = false;
							}
							if (res.data.response.personal_info === false) {
								formCompleted = false;
							}
							if (res.data.response.question === false) {
								formCompleted = false;
							}
							if (res.data.response.reference === false) {
								formCompleted = false;
							}
						} else {
							if (userData.is_mentor) {
								// Mentor/Volunteer
								if (res.data.response.additional_details === false) {
									formCompleted = false;
								}
								if (res.data.response.background === false) {
									formCompleted = false;
								}
								if (res.data.response.faith === false) {
									formCompleted = false;
								}
								if (res.data.response.personal_info === false) {
									formCompleted = false;
								}
								if (res.data.response.question === false) {
									formCompleted = false;
								}
								if (res.data.response.reference === false) {
									formCompleted = false;
								}
								if (res.data.response.opportunity === false) {
									formCompleted = false;
								}
							} else {
								// Volunteer
								if (res.data.response.additional_details === false) {
									formCompleted = false;
								}
								if (res.data.response.faith === false) {
									formCompleted = false;
								}
								if (res.data.response.opportunity === false) {
									formCompleted = false;
								}
								if (res.data.response.personal_info === false) {
									formCompleted = false;
								}
								if (res.data.response.question === false) {
									formCompleted = false;
								}
							}
						}

						if (!formCompleted) {
							this.backToOverview = false;
						} else {
							this.backToOverview = true;
						}
					})
					.catch((err) => {
						if (err.response) {
							this.isShow = true;
							this.errors = err.response.data.error.message;
						}
					});
			}
		},

		// Getting Current User Faith Details
		getFaith() {
			var userData = JSON.parse(localStorage.getItem('web_user'));
			var config = {
				headers: { Authorization: 'Bearer ' + userData.token },
			};
			if (userData.token) {
				axios
					.get('user/faith/' + userData['id'] + '?user_type_id=' + userData['user_type_id'], config)
					.then((res) => {
						if (res.status == 200) {
							this.addFaithForm = res.data.response;
						}
					})
					.catch((err) => {
						if (err.response) {
							// this.isShow = true;
							// this.errors = err.response.data.error.message;
						}
					});
			}
		},
		contactt() {
			router.push({ name: 'contact' });
		},
	},
};
</script>

<template>
	<div>
		<Header></Header>
		<div class="main-body">
			<div id="main-title" class="secondary">
				<div class="container">
					<div class="row mx-0">
						<div class="col-12 col-lg-6 align-self-center">
							<h3 class="title" v-if="userData.is_mentor">Mentor / Volunteer Details</h3>
							<h3 class="title" v-else>{{ userData['user_type_id'] === 3 ? 'Mentor' : 'Volunteer' }} Application</h3>
						</div>
						<div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
							<p class="need-help">Need Help ? <a @click="contactt" href="javascript:">Contact Us</a></p>
							<!--              <logout-button></logout-button>-->
						</div>
					</div>
				</div>
			</div>
			<div id="create-account">
				<div class="container">
					<div class="row mx-0 justify-content-center">
						<div class="col-12">
							<progressContainer :userData="userData" :active="'faith'" />
							<!-- <div class="progress-container" v-if="userData['user_type_id'] === 4">
                <div class="progress-box">
                  1
                </div>
                <div class="progress-box">
                  2
                </div>
                <div class="progress-box active">
                  3
                </div>
                <div class="progress-box">
                  4
                </div>
                <div class="progress-box">
                  5
                </div>
              </div>

              <div class="progress-container" v-else>
                <div class="progress-box">1</div>
                <div class="progress-box">2</div>
                <div class="progress-box">3</div>
                <div class="progress-box active">4</div>
                <div class="progress-box">5</div>
                <div class="progress-box">6</div>
              </div> -->
						</div>
					</div>
					<form @submit.prevent="addFaith" class="custom-form">
						<div class="row mx-0">
							<div class="row mx-0">
								<div class="col-12 mb-5">
									<h3 class="main-title">Faith Journey</h3>
								</div>
								<div v-show="isShow" class="alert alert-danger col-12">
									<span class="d-block" v-for="(error, index) in errors" :key="index">- {{ error }}</span>
								</div>
							</div>
							<!-- <div class="col-12 mb-5">
                <h3 class="main-title">Faith Journey</h3>
                <span class="font-size-16">MnTC is a faith-based program, although we provide recovery services to all clients regardless of
                  their religious beliefs. Completing the information below is optional, but it can provide helpful
                  context for placing you in a  {{ userData['user_type_id'] === 3 ? 'Mentors' : 'Volunteers' }} role.</span>
              </div> -->
						</div>
						<div class="row mx-0">
							<div class="col-12 mb-5">
								<label class="form-check-label">Do you Attended Place of Worship?</label>
								<b-form-radio v-model="addFaithForm.attend_worship" value="1" class="d-inline-block">Yes</b-form-radio>
								<b-form-radio v-model="addFaithForm.attend_worship" class="d-inline-block ms-4" value="0">No</b-form-radio>
							</div>
							<div class="col-12 col-md-4 mb-5">
								<input
									v-model="addFaithForm.location"
									type="text"
									placeholder="Enter place of worship *"
									class="form-control"
									name="location_name"
									:class="{ 'is-invalid': typeSubmit && $v.addFaithForm.location.$error && addFaithForm.attend_worship == 'yes', 'pe-none bg-secondary bg-soft': addFaithForm.attend_worship == 0 }"
								/>
								<div v-if="typeSubmit && $v.addFaithForm.location.$error && addFaithForm.attend_worship == '1'" class="invalid-feedback">
									<span v-if="!$v.addFaithForm.location.required">Location is required.</span>
								</div>
							</div>
							<div class="col-12 col-md-4 mb-5">
								<input v-model="addFaithForm.city" type="text" placeholder="Enter City *" class="form-control" name="city" :class="{ 'is-invalid': typeSubmit && $v.addFaithForm.city.$error && addFaithForm.attend_worship == '1', 'pe-none bg-secondary bg-soft': addFaithForm.attend_worship == 0 }" />
								<div v-if="typeSubmit && $v.addFaithForm.city.$error && addFaithForm.attend_worship == '1'" class="invalid-feedback">
									<span v-if="!$v.addFaithForm.city.required">City is required.</span>
								</div>
							</div>
							<div class="col-12 col-md-4 mb-5">
								<b-form-select class="form-select form-control" v-model="addFaithForm.state" :options="states" :class="{ 'is-invalid': typeSubmit && $v.addFaithForm.state.$error && addFaithForm.attend_worship == '1', 'pe-none bg-secondary bg-soft': addFaithForm.attend_worship == 0 }">
									<option slot="first" :value="null" selected>Select State</option>
								</b-form-select>
								<small class="d-inline-block ms-4 mt-2 font-size-14">Select State</small>

								<!-- <input v-model="addFaithForm.state" type="text" placeholder="Enter State" class="form-control" name="state"
                       :class="{ 'is-invalid': typeSubmit && $v.addFaithForm.state.$error && addFaithForm.attend_worship == '1' , 'pe-none bg-secondary bg-soft' : addFaithForm.attend_worship == 0 }" /> -->
								<div v-if="typeSubmit && $v.addFaithForm.state.$error && addFaithForm.attend_worship == '1'" class="invalid-feedback">
									<span v-if="!$v.addFaithForm.state.required">State is required.</span>
								</div>
							</div>
							<div class="col-12 col-md-12 mb-5">
								<label>
									<!-- Faith Involvement -->
									Please list any areas of involvement and/or service.
									<span v-if="userData['user_type_id'] == 4">(Optional)</span>
									<!-- <span v-if="addFaithForm.attend_worship != '1'">(Optional)</span> -->
								</label>
								<!-- <textarea v-model="addFaithForm.faith_involvement" class="form-control" name="faith_involvement" rows="3" :placeholder="addFaithForm.attend_worship == '1' ? 'Enter Faith Involvement *' : 'Enter Faith Involvement'"
                          :class="{ 'is-invalid': typeSubmit && $v.addFaithForm.faith_involvement.$error && addFaithForm.attend_worship == '1', '' : addFaithForm.attend_worship == 0 }" ></textarea>
                <div v-if="typeSubmit && $v.addFaithForm.faith_involvement.$error && addFaithForm.attend_worship == '1'" class="invalid-feedback">
                  <span v-if="!$v.addFaithForm.faith_involvement.required">Faith Involvement is required.</span>
                </div> -->
								<textarea
									v-model="addFaithForm.faith_involvement"
									class="form-control"
									name="faith_involvement"
									rows="3"
									:placeholder="userData['user_type_id'] == 3 ? 'Enter Faith Involvement *' : 'Enter Faith Involvement'"
									:class="{ 'is-invalid': typeSubmit && $v.addFaithForm.faith_involvement.$error && userData['user_type_id'] == 3, '': userData['user_type_id'] == 4 }"
								></textarea>
								<div v-if="typeSubmit && $v.addFaithForm.faith_involvement.$error && userData['user_type_id'] == 3" class="invalid-feedback">
									<span v-if="!$v.addFaithForm.faith_involvement.required">Faith Involvement is required.</span>
								</div>
							</div>
							<div class="col-12 col-md-12 mb-5">
								<label>
									<!-- Faith Journey -->
									Please describe your personal faith journey.
									<!-- <span v-if="addFaithForm.attend_worship != '1'">(Optional)</span> -->
									<span v-if="userData['user_type_id'] == 4">(Optional)</span>
								</label>
								<!-- <textarea 
                  v-model="addFaithForm.faith_journey"
                  class="form-control"
                  name="faith_journey"
                  rows="3"
                  :placeholder="addFaithForm.attend_worship == '1' ? 'Enter Faith Journey *' : 'Enter Faith Journey'"
                  :class="{ 'is-invalid': typeSubmit && $v.addFaithForm.faith_journey.$error }"
                >
                </textarea> -->
								<textarea
									v-model="addFaithForm.faith_journey"
									class="form-control"
									name="faith_journey"
									rows="3"
									:placeholder="userData['user_type_id'] == 3 ? 'Enter Faith Journey *' : 'Enter Faith Journey'"
									:class="{ 'is-invalid': typeSubmit && $v.addFaithForm.faith_journey.$error && userData['user_type_id'] == 3, '': userData['user_type_id'] == 4 }"
								>
								</textarea>
								<small class="d-inline-block ms-4 mt-2 font-size-14">(500 words or less)</small>
								<div v-if="typeSubmit && $v.addFaithForm.faith_journey.$error" class="invalid-feedback">
									<span v-if="!$v.addFaithForm.faith_journey.required">Faith Journey is required.</span>
									<span v-if="!$v.addFaithForm.faith_journey.maxLength">This value is too long. It should have 500 words or less</span>
								</div>
							</div>
						</div>
						<div class="row mx-0">
							<div class="mb-2 col-12 d-flex flex-column flex-md-row justify-content-start justify-content-md-end align-items-stretch align-items-md-start" v-if="backToOverview">
								<b-button type="button" @click="skipToReview" variant="custom">
									<i class="font-size-20 me-2 bx bxs-right-arrow-circle"></i>
									Skip To Review
								</b-button>
							</div>
							<div class="mb-5 col-12 d-flex flex-column-reverse flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start" v-if="userData['user_type_id'] === 4 && !userData.is_mentor">
								<b-button type="button" @click="questions" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Applicant History</b-button>
								<b-button type="button" @click="addFaith" variant="custom">Additional Details <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
							</div>
							<div class="mb-5 col-12 d-flex flex-column-reverse flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start" v-else>
								<b-button type="button" @click="questions" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Applicant History</b-button>
								<b-button type="button" @click="addFaith" variant="custom">Interests, Skills, Involvement <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
							</div>
							<!-- <div class="mb-5 col-12 d-flex flex-column-reverse flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start" v-else-if="userData.is_mentor">
                  <b-button type="button" @click="backgroundCheckDetails" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Background Check Details</b-button>
                  <b-button type="button" @click="addFaith" variant="custom">References <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
                </div> -->
						</div>
					</form>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
